var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sales-channel",class:_vm.themeClass,attrs:{"id":"app"}},[(_vm.loading)?_c('LoadingSpinner',{staticClass:"spinner",attrs:{"size":140}}):_c('Default',{style:(_vm.cssProps)},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }